import { BASE_PATH as y, BaseAPI as O, operationServerMap as S } from "../base.js";
import { DUMMY_BASE_URL as c, assertParamExists as C, createRequestFunction as u, serializeDataIfNeeded as h, setSearchParams as v, toPathString as G } from "../common.js";
import P from "axios";
var V = function(s) {
  return {
    employeeCommissionStatGetCommissionDetailPage: async (m, t = {}) => {
      C("employeeCommissionStatGetCommissionDetailPage", "employeeCommissionDetailQueryDTO", m);
      const i = new URL("/merchant/dc/employee_commission/detail/page", c);
      let o;
      s && (o = s.baseOptions);
      const e = {
        method: "POST",
        ...o,
        ...t
      }, a = {}, r = {};
      a["Content-Type"] = "application/json", v(i, r);
      let n = o && o.headers ? o.headers : {};
      return e.headers = {
        ...a,
        ...n,
        ...t.headers
      }, e.data = h(m, e, s), {
        url: G(i),
        options: e
      };
    },
    employeeCommissionStatGetCommissionRecordGrouped: async (m, t = {}) => {
      C("employeeCommissionStatGetCommissionRecordGrouped", "employeeCommissionRecordGroupedRequest", m);
      const i = new URL("/merchant/dc/employee_commission/record/grouped", c);
      let o;
      s && (o = s.baseOptions);
      const e = {
        method: "POST",
        ...o,
        ...t
      }, a = {}, r = {};
      a["Content-Type"] = "application/json", v(i, r);
      let n = o && o.headers ? o.headers : {};
      return e.headers = {
        ...a,
        ...n,
        ...t.headers
      }, e.data = h(m, e, s), {
        url: G(i),
        options: e
      };
    },
    employeeCommissionStatGetCommissionRecordPage: async (m, t = {}) => {
      C("employeeCommissionStatGetCommissionRecordPage", "commissionStatQueryDTO", m);
      const i = new URL("/merchant/dc/employee_commission/record/page", c);
      let o;
      s && (o = s.baseOptions);
      const e = {
        method: "POST",
        ...o,
        ...t
      }, a = {}, r = {};
      a["Content-Type"] = "application/json", v(i, r);
      let n = o && o.headers ? o.headers : {};
      return e.headers = {
        ...a,
        ...n,
        ...t.headers
      }, e.data = h(m, e, s), {
        url: G(i),
        options: e
      };
    },
    employeeCommissionStatGetCommissionStatPage: async (m, t = {}) => {
      C("employeeCommissionStatGetCommissionStatPage", "commissionStatQueryDTO", m);
      const i = new URL("/merchant/dc/employee_commission/stat/page", c);
      let o;
      s && (o = s.baseOptions);
      const e = {
        method: "POST",
        ...o,
        ...t
      }, a = {}, r = {};
      a["Content-Type"] = "application/json", v(i, r);
      let n = o && o.headers ? o.headers : {};
      return e.headers = {
        ...a,
        ...n,
        ...t.headers
      }, e.data = h(m, e, s), {
        url: G(i),
        options: e
      };
    },
    employeeCommissionStatGetCommissionStatSummary: async (m, t = {}) => {
      C("employeeCommissionStatGetCommissionStatSummary", "commissionStatQueryDTO", m);
      const i = new URL("/merchant/dc/employee_commission/stat/summary", c);
      let o;
      s && (o = s.baseOptions);
      const e = {
        method: "POST",
        ...o,
        ...t
      }, a = {}, r = {};
      a["Content-Type"] = "application/json", v(i, r);
      let n = o && o.headers ? o.headers : {};
      return e.headers = {
        ...a,
        ...n,
        ...t.headers
      }, e.data = h(m, e, s), {
        url: G(i),
        options: e
      };
    },
    employeeCommissionStatGetMyCommissionRecordPage: async (m, t = {}) => {
      C("employeeCommissionStatGetMyCommissionRecordPage", "commissionStatQueryDTO", m);
      const i = new URL("/merchant/dc/employee_commission/my/record/page", c);
      let o;
      s && (o = s.baseOptions);
      const e = {
        method: "POST",
        ...o,
        ...t
      }, a = {}, r = {};
      a["Content-Type"] = "application/json", v(i, r);
      let n = o && o.headers ? o.headers : {};
      return e.headers = {
        ...a,
        ...n,
        ...t.headers
      }, e.data = h(m, e, s), {
        url: G(i),
        options: e
      };
    },
    employeeCommissionStatGetMyCommissionStatSummary: async (m, t = {}) => {
      C("employeeCommissionStatGetMyCommissionStatSummary", "commissionStatQueryDTO", m);
      const i = new URL("/merchant/dc/employee_commission/my/stat/summary", c);
      let o;
      s && (o = s.baseOptions);
      const e = {
        method: "POST",
        ...o,
        ...t
      }, a = {}, r = {};
      a["Content-Type"] = "application/json", v(i, r);
      let n = o && o.headers ? o.headers : {};
      return e.headers = {
        ...a,
        ...n,
        ...t.headers
      }, e.data = h(m, e, s), {
        url: G(i),
        options: e
      };
    }
  };
}, d = function(s) {
  const m = V(s);
  return {
    async employeeCommissionStatGetCommissionDetailPage(t, i) {
      var o, e;
      const a = await m.employeeCommissionStatGetCommissionDetailPage(t, i), r = (o = s == null ? void 0 : s.serverIndex) !== null && o !== void 0 ? o : 0, n = (e = S["EmployeeCommissionStatApi.employeeCommissionStatGetCommissionDetailPage"]) === null || e === void 0 || (e = e[r]) === null || e === void 0 ? void 0 : e.url;
      return (l, p) => u(a, P, y, s)(l, n || p);
    },
    async employeeCommissionStatGetCommissionRecordGrouped(t, i) {
      var o, e;
      const a = await m.employeeCommissionStatGetCommissionRecordGrouped(t, i), r = (o = s == null ? void 0 : s.serverIndex) !== null && o !== void 0 ? o : 0, n = (e = S["EmployeeCommissionStatApi.employeeCommissionStatGetCommissionRecordGrouped"]) === null || e === void 0 || (e = e[r]) === null || e === void 0 ? void 0 : e.url;
      return (l, p) => u(a, P, y, s)(l, n || p);
    },
    async employeeCommissionStatGetCommissionRecordPage(t, i) {
      var o, e;
      const a = await m.employeeCommissionStatGetCommissionRecordPage(t, i), r = (o = s == null ? void 0 : s.serverIndex) !== null && o !== void 0 ? o : 0, n = (e = S["EmployeeCommissionStatApi.employeeCommissionStatGetCommissionRecordPage"]) === null || e === void 0 || (e = e[r]) === null || e === void 0 ? void 0 : e.url;
      return (l, p) => u(a, P, y, s)(l, n || p);
    },
    async employeeCommissionStatGetCommissionStatPage(t, i) {
      var o, e;
      const a = await m.employeeCommissionStatGetCommissionStatPage(t, i), r = (o = s == null ? void 0 : s.serverIndex) !== null && o !== void 0 ? o : 0, n = (e = S["EmployeeCommissionStatApi.employeeCommissionStatGetCommissionStatPage"]) === null || e === void 0 || (e = e[r]) === null || e === void 0 ? void 0 : e.url;
      return (l, p) => u(a, P, y, s)(l, n || p);
    },
    async employeeCommissionStatGetCommissionStatSummary(t, i) {
      var o, e;
      const a = await m.employeeCommissionStatGetCommissionStatSummary(t, i), r = (o = s == null ? void 0 : s.serverIndex) !== null && o !== void 0 ? o : 0, n = (e = S["EmployeeCommissionStatApi.employeeCommissionStatGetCommissionStatSummary"]) === null || e === void 0 || (e = e[r]) === null || e === void 0 ? void 0 : e.url;
      return (l, p) => u(a, P, y, s)(l, n || p);
    },
    async employeeCommissionStatGetMyCommissionRecordPage(t, i) {
      var o, e;
      const a = await m.employeeCommissionStatGetMyCommissionRecordPage(t, i), r = (o = s == null ? void 0 : s.serverIndex) !== null && o !== void 0 ? o : 0, n = (e = S["EmployeeCommissionStatApi.employeeCommissionStatGetMyCommissionRecordPage"]) === null || e === void 0 || (e = e[r]) === null || e === void 0 ? void 0 : e.url;
      return (l, p) => u(a, P, y, s)(l, n || p);
    },
    async employeeCommissionStatGetMyCommissionStatSummary(t, i) {
      var o, e;
      const a = await m.employeeCommissionStatGetMyCommissionStatSummary(t, i), r = (o = s == null ? void 0 : s.serverIndex) !== null && o !== void 0 ? o : 0, n = (e = S["EmployeeCommissionStatApi.employeeCommissionStatGetMyCommissionStatSummary"]) === null || e === void 0 || (e = e[r]) === null || e === void 0 ? void 0 : e.url;
      return (l, p) => u(a, P, y, s)(l, n || p);
    }
  };
}, M = function(s, m, t) {
  const i = d(s);
  return {
    employeeCommissionStatGetCommissionDetailPage(o, e) {
      return i.employeeCommissionStatGetCommissionDetailPage(o.employeeCommissionDetailQueryDTO, e).then((a) => a(t, m));
    },
    employeeCommissionStatGetCommissionRecordGrouped(o, e) {
      return i.employeeCommissionStatGetCommissionRecordGrouped(o.employeeCommissionRecordGroupedRequest, e).then((a) => a(t, m));
    },
    employeeCommissionStatGetCommissionRecordPage(o, e) {
      return i.employeeCommissionStatGetCommissionRecordPage(o.commissionStatQueryDTO, e).then((a) => a(t, m));
    },
    employeeCommissionStatGetCommissionStatPage(o, e) {
      return i.employeeCommissionStatGetCommissionStatPage(o.commissionStatQueryDTO, e).then((a) => a(t, m));
    },
    employeeCommissionStatGetCommissionStatSummary(o, e) {
      return i.employeeCommissionStatGetCommissionStatSummary(o.commissionStatQueryDTO, e).then((a) => a(t, m));
    },
    employeeCommissionStatGetMyCommissionRecordPage(o, e) {
      return i.employeeCommissionStatGetMyCommissionRecordPage(o.commissionStatQueryDTO, e).then((a) => a(t, m));
    },
    employeeCommissionStatGetMyCommissionStatSummary(o, e) {
      return i.employeeCommissionStatGetMyCommissionStatSummary(o.commissionStatQueryDTO, e).then((a) => a(t, m));
    }
  };
}, T = class extends O {
  employeeCommissionStatGetCommissionDetailPage(s, m) {
    return d(this.configuration).employeeCommissionStatGetCommissionDetailPage(s.employeeCommissionDetailQueryDTO, m).then((t) => t(this.axios, this.basePath));
  }
  employeeCommissionStatGetCommissionRecordGrouped(s, m) {
    return d(this.configuration).employeeCommissionStatGetCommissionRecordGrouped(s.employeeCommissionRecordGroupedRequest, m).then((t) => t(this.axios, this.basePath));
  }
  employeeCommissionStatGetCommissionRecordPage(s, m) {
    return d(this.configuration).employeeCommissionStatGetCommissionRecordPage(s.commissionStatQueryDTO, m).then((t) => t(this.axios, this.basePath));
  }
  employeeCommissionStatGetCommissionStatPage(s, m) {
    return d(this.configuration).employeeCommissionStatGetCommissionStatPage(s.commissionStatQueryDTO, m).then((t) => t(this.axios, this.basePath));
  }
  employeeCommissionStatGetCommissionStatSummary(s, m) {
    return d(this.configuration).employeeCommissionStatGetCommissionStatSummary(s.commissionStatQueryDTO, m).then((t) => t(this.axios, this.basePath));
  }
  employeeCommissionStatGetMyCommissionRecordPage(s, m) {
    return d(this.configuration).employeeCommissionStatGetMyCommissionRecordPage(s.commissionStatQueryDTO, m).then((t) => t(this.axios, this.basePath));
  }
  employeeCommissionStatGetMyCommissionStatSummary(s, m) {
    return d(this.configuration).employeeCommissionStatGetMyCommissionStatSummary(s.commissionStatQueryDTO, m).then((t) => t(this.axios, this.basePath));
  }
};
export {
  T as EmployeeCommissionStatApi,
  V as EmployeeCommissionStatApiAxiosParamCreator,
  M as EmployeeCommissionStatApiFactory,
  d as EmployeeCommissionStatApiFp
};

//# sourceMappingURL=employee-commission-stat-api.js.map